import { useSyncExternalStore } from "react";

const STORAGE_KEY = "kr-ethic-favorites";

function readFavorites(): string[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as string[]) : [];
  } catch {
    return [];
  }
}

let favorites: string[] = readFavorites();
const listeners = new Set<() => void>();

function persist() {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites));
  } catch {
    /* ignore quota / privacy errors */
  }
}

function emit() {
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function getSnapshot() {
  return favorites;
}

function toggleFavorite(id: string) {
  if (favorites.includes(id)) {
    favorites = favorites.filter((item) => item !== id);
  } else {
    favorites = [...favorites, id];
  }
  persist();
  emit();
}

function removeFavorite(id: string) {
  if (!favorites.includes(id)) return;
  favorites = favorites.filter((item) => item !== id);
  persist();
  emit();
}

export function useFavorites() {
  const list = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  return {
    favorites: list,
    count: list.length,
    isFavorite: (id: string) => list.includes(id),
    toggleFavorite,
    removeFavorite,
  };
}